import { productClassNames } from "../types/AbstractCase";
import * as status from "./LeadStatus/StatusBasicCase";
import { getProductData } from "./Product/ProductService/productService";
import { ProductUnion } from "../types/ProductUnion";

const defaultAvailability = {
  getForAppointment: (product: ProductUnion) => product.leadStatus >= status.STATUS_DATA_COMPLETED,
  getForInformationAndDocuments: (product: ProductUnion) =>
    product.stage >= getProductData(product.productClassName, "setBackCaseStage"),
  getForDocuments: (product: ProductUnion) =>
    product.stage >= getProductData(product.productClassName, "setBackCaseStage"),
  getForInformation: (product: ProductUnion) =>
    product.stage >= getProductData(product.productClassName, "setBackCaseStage"),
};

export const inquiryTypeAvailability: {
  [K in typeof productClassNames[number]]: {
    getForAppointment: (product: ProductUnion) => boolean;
    getForInformationAndDocuments: (product: ProductUnion) => boolean;
    getForDocuments: (product: ProductUnion) => boolean;
    getForInformation: (product: ProductUnion) => boolean;
  };
} = {
  divorce: {
    getForAppointment: () => true,
    getForInformationAndDocuments: () => true,
    getForDocuments: () => true,
    getForInformation: () => true,
  },
  familyLawCase: defaultAvailability,
  alimony: defaultAvailability,
  civilServiceLaw: defaultAvailability,
  dataLeakContract: defaultAvailability,
  death: defaultAvailability,
  employmentContract: defaultAvailability,
  eventContract: defaultAvailability,
  generalCivilLaw: defaultAvailability,
  membershipContract: defaultAvailability,
  otherContract: defaultAvailability,
  patientDecree: defaultAvailability,
  pendingCase: {
    getForAppointment: () => false,
    getForInformationAndDocuments: () => false,
    getForDocuments: () => false,
    getForInformation: () => false,
  },
  powerOfAttorney: defaultAvailability,
  providerContract: defaultAvailability,
  purchaseContract: defaultAvailability,
  rentalContract: defaultAvailability,
  serviceContract: defaultAvailability,
  settlement: defaultAvailability,
  shortTimeWork: defaultAvailability,
  subscriptionContract: defaultAvailability,
  traffic: defaultAvailability,
  trafficAccident: defaultAvailability,
  travelContract: defaultAvailability,
  vehicleContract: defaultAvailability,
};
